import { inject, provideAppInitializer } from '@angular/core';

import { RoutesService } from '@abp/ng.core';

// ABP ships 'fa fa-id-card-o', a FontAwesome 4 name missing from FontAwesome 7, so the menu shows the missing-icon glyph.
// Register after provideIdentityConfig(): initializers run in provider order.
export const provideIdentityMenuIcon = () =>
  provideAppInitializer(() => {
    inject(RoutesService).patch('AbpIdentity::Menu:IdentityManagement', { iconClass: 'fas fa-id-card' });
  });
